function EditGoal() {
    return (
        <div>
            <h1>Edit Goal</h1>
        </div>
    )
}

export default EditGoal;